export const ELLIPSIS = '…';
/** 1em per code point at 8.5pt: every bundled glyph is narrower, so this can
 *  only over-cut, never wrap. Used when no canvas exists. */
export const fallbackMeasure = (text) => [...text].length * 8.5;
/** Cuts `text` only when its measured width overflows the box. */
export function fitText(text, boxWidthPt, measure) {
    if (measure(text) <= boxWidthPt)
        return text;
    const points = [...text];
    for (let n = points.length - 1; n > 0; n--) {
        const candidate = points.slice(0, n).join('') + ELLIPSIS;
        if (measure(candidate) <= boxWidthPt)
            return candidate;
    }
    return measure(ELLIPSIS) <= boxWidthPt ? ELLIPSIS : '';
}
//# sourceMappingURL=fit-text.js.map